import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Flex, Input as ThemeUiInput, Label } from 'theme-ui'

import Text from '~/components/IntlComponents/Text'

const Input = forwardRef(
  ({ label, subLabel = '', type = 'text', errorText, sx, ...props }, ref) => {
    const wrapperStyle = {
      flexFlow: 'wrap column',
      width: '100%',
      ...sx,
    }

    const labelStyle = {
      fontFamily: 'heading',
      marginBottom: '10px',
      color: 'secondary',
    }

    const errorStyle = {
      color: 'error',
      fontWeight: 'body',
      marginTop: '6px',
    }

    return (
      <Flex sx={wrapperStyle}>
        {label && (
          <Label htmlFor={props.name} sx={labelStyle}>
            {label}
          </Label>
        )}
        <Flex sx={{ flexFlow: 'column', width: '100%' }}>
          <ThemeUiInput
            {...props}
            id={props.name}
            variant="forms.input.gift"
            type={type}
            ref={ref}
          />
          {subLabel && (
            <Text
              sx={{
                ...labelStyle,
                fontWeight: 'body',
                marginTop: '6px',
                fontSize: '0.75rem',
              }}
            >
              {subLabel}
            </Text>
          )}
          {errorText && <Text sx={errorStyle}>{errorText}</Text>}
        </Flex>
      </Flex>
    )
  },
)

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  errorText: PropTypes.string,
  sx: PropTypes.object,
}

export default Input
